export default function getAssetUrl(url?: string | null): string {
  if (!url) return ''
  return !url?.includes('http') ? `http://localhost${url}` : url
}
